const TabList = require('ffss/ui/TabList');


class NewsList {
    defaultOptions() {
        return {
            '$container': null,
        };
    }

    constructor(options) {
        this.settings = $.extend(this.defaultOptions(), options);

        this.$container = this.settings.$container;
        if(!this.$container){
            window.notify("$container is missing in component/row/NewsList ","error");
        }

        this.$tabLinkList = $('.tab-list',this.$container);

        this.initialize();
    }


    initialize(){
        var self = this;


        this.tabList = new TabList({
            '$mainContainer': this.$container,
            '$container': this.$tabLinkList,

            'linkSelector': '.btn-news-categorie',
            'itemSelector': '.news-list-item',
            'activeClass': 'active',
            'countSelector': '.count',

            'fieldName': 'categorie',
        });

    }

}

module.exports = NewsList;